export const BuyModal = () => {
  return <h3 className="h3">Buy Crypto</h3>;
};
